import { render, staticRenderFns } from "./RequestPrice.vue?vue&type=template&id=4545aa69&"
import script from "./RequestPrice.vue?vue&type=script&lang=js&"
export * from "./RequestPrice.vue?vue&type=script&lang=js&"
import style0 from "./RequestPrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RequestPrice.vue"
export default component.exports